import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { isAuthenticated } from "@/auth";
import { InstallNotStarted } from "@/components/installFlowV2/install-not-started";

export const Route = createFileRoute("/installFlow/install-not-started")({
  component: InstallNotStarted,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
  },
});
